import L from 'leaflet';

const DEFAULTS = {
	center: [46.801111, 8.226667],
	zoom: 12,
	maxZoom: 18,
	minZoom: 0,
	zoomDelta: 1,
	zoomSnap: 1,
	maxBounds: null,
	fadeAnimation: false,
	attributionControl: false,
};

/**
 * @extends {L.Evented}
 */
class MapManagement extends L.Evented {
	/**
	 * @param {Widget} widget
	 * @param {object} options
	 * @param {L.LatLng} [options.center=[46.801111, 8.226667]]
	 * @param {number} [options.zoom=12]
	 * @param {number} [options.maxZoom=18]
	 * @param {number} [options.minZoom=0]
	 * @param {number} [options.zoomDelta=1]
	 * @param {number} [options.zoomSnap=1]
	 * @param {L.LatLngBounds} [options.maxBounds]
	 * @param {boolean} [options.fadeAnimation=false]
	 * @param {boolean} [options.attributionControl=false]
	 */
	constructor(widget, options) {
		super();

		this.widget = widget;
		this.options = Object.assign({}, DEFAULTS, options);
		this.options.center = L.latLng(this.options.center);
		this.addEventParent(widget);

		this._container = L.DomUtil.create('div', 'widget-map', widget._container);

		this._map = L.map(this._container, this.options);
		this._map.addEventParent(this);
	}

	/**
	 * @param {L.Layer} layer
	 */
	addLayer(layer) {
		this._map.addLayer(layer);
	}

	/**
	 * @param {L.Layer} layer
	 */
	removeLayer(layer) {
		this._map.removeLayer(layer);
	}

	/**
	 *
	 */
	destroy() {
		this.removeEventParent(this.widget);

		this._map.remove();
		L.DomUtil.remove(this._container);
	}
}

export function mapManagement(widget, options) {
	return new MapManagement(widget, options);
}

export default MapManagement;
